import React, { Component } from 'react';
import { SelectCom } from './select-com';
import { SaveLayout } from './save-layout';
import Workspace from './workspace';
import Reload from './Reload';
import { Excel } from './excel';
import { SaveSystemSetting } from './save-system-setting';

class SideBar extends Component {
  render() {
    return (
      <div className="sideleft-section">
        <ul>
          <SelectCom {...this.props} />
          <Workspace />
          <SaveLayout />
          <Reload />
          <Excel />
          <SaveSystemSetting />
        </ul>
      </div>
    );
  }
}

export default SideBar;
